.th {
    border: 1px solid;
}